export var THDFormGroupStyles = {};
